import React from "react";
import { X, FileText } from "lucide-react";
import { motion } from "framer-motion";

const Popup = ({ content, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center p-4 z-[100]">
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      />

      {/* Modal Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        className="relative w-full max-w-lg bg-white dark:bg-gray-900 rounded-3xl shadow-2xl border border-gray-100 dark:border-blue-gray-900 overflow-hidden"
      >
        {/* Header */}
        <div className="px-6 py-4 flex justify-between items-center border-b border-gray-50 dark:border-gray-800/50 bg-gray-50/50 dark:bg-gray-800/30">
          <div className="flex items-center gap-2.5">
            <div className="p-2 bg-blue-50 dark:bg-blue-500/10 rounded-xl">
              <FileText className="w-4 h-4 text-blue-600 dark:text-blue-400" />
            </div>
            <h2 className="text-base font-bold text-gray-900 dark:text-white tracking-tight">Request Details</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full text-gray-400 hover:text-gray-900 dark:text-gray-500 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-90"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-8 py-8">
          <div className="bg-gray-50/50 dark:bg-black/20 rounded-2xl p-6 border border-gray-100 dark:border-gray-800/50">
            <p className="text-[14px] text-gray-700 dark:text-gray-300 leading-relaxed font-medium whitespace-pre-wrap">
              {content || "No details provided."}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50/30 dark:bg-gray-800/20 border-t border-gray-50 dark:border-gray-800/30 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-900 dark:bg-white text-white dark:text-gray-900 text-xs font-bold rounded-xl hover:opacity-90 transition-opacity active:scale-95 shadow-lg shadow-black/10"
          >
            Close
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default Popup;
